export const TOGGLE_DEVICE = 'TOGGLE_DEVICE'

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'

export const EXPAND_MENU = 'EXPAND_MENU'

export const SWITCH_EFFECT = 'SWITCH_EFFECT'

export const AUTH = 'SET_USER'

export const RECOVERY_PASSWORD = 'RECOVERY_PASSWORD'

export const CUSTOMER = 'CUSTOMER'

export const SCHEDULE = 'SCHEDULE'

export const THEME = 'THEME'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js